import { RadioButtonCard } from "components/InputCards/RadioButtonCard";
import React, { useMemo } from "react";

export const ConfiguratorRadioBtn = ({
  option,
  onChange,
  partKey,
  value,
  disabled,
  isModalView,
}) => {
  const options = useMemo(
    () =>
      option.signatures
        .filter((sig) => sig.state !== 2)
        .map((sig) => ({
          label: `${sig.title}${
            sig.presentation ? ` (${sig.presentation})` : ""
          }`,
          value: sig.key || sig.value,
          description: sig.description,
          state: sig.state,
        })),
    [option.signatures],
  );

  return (
    <RadioButtonCard
      label={option.title}
      options={options}
      value={value}
      onChange={onChange}
      partKey={partKey}
      optionKey={option.key}
      description={option.description}
      disabled={disabled}
      isModalView={isModalView}
    />
  );
};
